import { DatePipe } from "@angular/common"
import { ClassOffering } from "./class-offering.model"
import { CourseInstructorDTO } from "./course-instructor-dto.model"
import { ElectronicAddress } from "./electronic-address.model"
import { DropdownOption } from "@cms/shared-library"
import { ClassNotification } from "./class-notification.model"

export class CourseSchedule {
  public Expanded: boolean = false;
  constructor(
    public CourseId: string,
    public Name: string,
    public NameFr: string,
    public Cost: number,
    public TrainingProviderName: string,
    public TrainingTypeName: string,
    public TrainingTypeNameFr: string,
    public InstructorName: string,
    public PostalCode: string,
    public AddressLine: string,
    public AptSuiteUnit: string,
    public PoBox: string,
    public CityTown: string,
    public Province: string,
    public Country: string,
    public Capacity: number,
    public SeatsRegistered: number,
    public Classes: ClassOffering[],
    public ElectronicAddresses: ElectronicAddress[],
    public CourseInstructors: CourseInstructorDTO[],
    public Language: string,
    public Status?: number,
    public StatusLastUpdateDate?: Date,
    public SeatsConfirmed?: number,
    public UnreadNotifications?: number,
    public CustomCourseName?: string,
    public CompletedRegistrations?: number,
    public PendingEnrolmentsCount?: number,
    public FirstClassDate?: Date,
    public LearnerNotification?: ClassNotification,
    public NewInstructorOptions?: DropdownOption[],
    public CurrentCourseInstructorsAndEvaluator?: CourseInstructorDTO[],
    public IsCurrentTmCourseInstructor?: boolean,
    public IsCurrentTmCourseEvaluator?: boolean
  ) { }

  public getSeatsAvailable(): number {
    if (this.SeatsConfirmed == null) {
      return this.Capacity
    }
    else {
      return this.Capacity - this.SeatsConfirmed
    }
  }

  public formatAddress(): string {
    var str = this.AddressLine;
    if (str && this.CityTown) str = str + ', ' + this.CityTown;
    if (str && this.Province) str = str + ' ' + this.Province;
    if (str && this.PostalCode) str = str + ', ' + this.PostalCode;
    return str;
  }

  public getDatesAsComboString(datePipe: DatePipe): string {
    let dateCombo: string = ""
    let prevMonth: string | null

    this.Classes.forEach(x => {
      let curMonth = datePipe.transform(x.StartDate, 'MMMM')
      let curDay = datePipe.transform(x.StartDate, 'd')

      if (prevMonth == null || curMonth != prevMonth) {

        if (dateCombo.length >= 2) {
          dateCombo = dateCombo.substring(0, dateCombo.length - 3)
          dateCombo += ', '
        }
        dateCombo += `${curMonth} ${curDay} & `
        prevMonth = curMonth
      } else {
        dateCombo += `${curDay} & `
      }
    })

    if (dateCombo.length >= 2) dateCombo = dateCombo.substring(0, dateCombo.length - 2)
    dateCombo = dateCombo.trim()
    return dateCombo
  }

  public getTimeAsComboString(datePipe: DatePipe): string {
    let timeArray: string[] = []
    let allAreSameTime = true

    this.Classes.forEach(x => {
      let curTime = `${datePipe.transform(x.StartDate, 'h:mm a')} to ${datePipe.transform(x.EndDate, 'h:mm a')}`
      if (allAreSameTime && timeArray.length > 0 && timeArray[timeArray.length - 1] != curTime) allAreSameTime = false
      timeArray.push(curTime)
    })

    return allAreSameTime ? timeArray[0] : timeArray.join(', ')
  }

  public getDaysOfWeekAsComboString(datePipe: DatePipe): string {
    let dayOfWeek: string[] = []
    let allAreSameDayOfWeek = true

    this.Classes.forEach(x => {
      let curDayOfWeek = `${datePipe.transform(x.StartDate, 'EEE')}`
      if (allAreSameDayOfWeek && dayOfWeek.length > 0 && dayOfWeek[dayOfWeek.length - 1] != curDayOfWeek) allAreSameDayOfWeek = false
      dayOfWeek.push(curDayOfWeek)
    })

    return allAreSameDayOfWeek ? dayOfWeek[0] : dayOfWeek.join(' & ')
  }
}
